import { Reveal } from "./Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function Pathways() {
  const { t } = useLanguage();

  const PATHWAYS = [
    { n: "01", name: "NCAA Division I", desc: t("pathways.d1"), tag: t("pathways.d1tag") },
    { n: "02", name: "NCAA Division II", desc: t("pathways.d2"), tag: t("pathways.d2tag") },
    { n: "03", name: "NCAA Division III", desc: t("pathways.d3"), tag: t("pathways.d3tag") },
    { n: "04", name: "NAIA", desc: t("pathways.d4"), tag: t("pathways.d4tag") },
    { n: "05", name: "NJCAA", desc: t("pathways.d5"), tag: t("pathways.d5tag") },
    { n: "06", name: "U Sports", desc: t("pathways.d6"), tag: t("pathways.d6tag") },
  ];

  return (
    <section id="pathways" className="py-24 md:py-40" data-testid="pathways-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 mb-16 md:mb-24">
        <Reveal>
          <p className="font-jetbrains text-xs uppercase tracking-[0.35em] text-volt mb-6">{t("pathways.chapter")}</p>
          <h2 className="font-cabinet font-black uppercase text-4xl md:text-6xl leading-[0.95] tracking-tight max-w-4xl">
            {t("pathways.h2a")}<span className="text-outline">{t("pathways.h2b")}</span>{t("pathways.h2c")}
          </h2>
        </Reveal>
      </div>

      <div className="border-b border-white/10">
        {PATHWAYS.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.05} y={24}>
            <div
              className="group border-t border-white/10 hover:bg-white/[0.04] transition-colors duration-500"
              data-testid={`pathway-row-${p.n}`}
            >
              <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-8 md:py-10 grid md:grid-cols-12 gap-4 md:gap-8 items-start">
                <span className="md:col-span-2 font-cabinet font-black text-5xl md:text-7xl text-outline group-hover:text-outline-volt transition-all duration-500 leading-none">
                  {p.n}
                </span>
                <h3 className="md:col-span-3 font-cabinet font-bold uppercase text-2xl md:text-3xl tracking-tight pt-1">
                  {p.name}
                </h3>
                <p className="md:col-span-5 text-white/60 leading-relaxed text-base md:text-lg">
                  {p.desc}
                </p>
                <span className="md:col-span-2 font-jetbrains text-[10px] md:text-xs uppercase tracking-[0.25em] text-volt/80 md:text-right md:pt-3">
                  {p.tag}
                </span>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
